// extracted by mini-css-extract-plugin
export default {"pageViews":"Dashboard__pageViews___Bs8VA","usersOnline":"Dashboard__usersOnline___HNmn3"};